import * as Yup from 'yup';

/**
 * Schéma des mandants d'un deviseur mandataire : au moins un courtier mandant ;
 * les tunnels par mandant sont libres (0 tunnel = liaison sans accès, complétée
 * plus tard). La couverture (tunnel ⊆ habilitations du mandant) est re-validée
 * côté serveur.
 */
export const mandantsArraySchema = Yup.array()
  .of(
    Yup.object({
      courtierId: Yup.string().required(),
      tunnelIds: Yup.array().of(Yup.string().required()).defined(),
    }),
  )
  .min(1, 'Au moins un courtier mandant est requis');
